import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const leftSidebarAtom = atomWithStorage('leftSidebar', true);

export function useLeftSidebar() {
  const [showLeftSidebar, setShowLeftSidebar] = useAtom(leftSidebarAtom);
  return { showLeftSidebar, setShowLeftSidebar };
}
